module.exports = __webpack_public_path__ + "static/FoundryGridnik-Regular-9027b7db629af8ffe29abe981ddc44ed.woff2";